import { AccessorsMutatorsDecorator } from "../../helpers";
import { TranslatableModel } from "./translatable-model";
import { Property } from './property.model';

/**
 * @class Furniture
 * 
 */
export class Furniture extends TranslatableModel {
    
    /**
     * @type {string[]}
     */
    static get translatableAttributes() {
        
        return [ 'title' ];
    }
    
    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {
        
        return value instanceof Property ? value : new Property(value);
    }
}

AccessorsMutatorsDecorator('id', ...Furniture.translatableAttributesWithLanguageAliases, 'property_id', 'supplier_id', 'item_number', 'items', 'price', 'description', 'property', 'supplier', 'supplier_name', 'updated_at')(Furniture);


// WEBPACK FOOTER //
// ./src/pms-api/models/furniture.model.js